import { useNuxtApp } from "#app"
import { SAVED_PROFILE_IMAGE } from "assets/events/api.js"

export default defineNuxtPlugin((nuxtApp) => {
	const { $userApiService, $messages, $eventBus } = useNuxtApp()
	const runtimeConfig = useRuntimeConfig()
	const userStore = useUserStore()
	const qrInfoStore = useQrStore()
	const toastStore = useToastStore()
	const orderStore = useOrderStore()
	const credentialStore = useCredentialStore()
	const eventStore = useEventStore()
	const notificationStore = useNotificationStore()
	let latestQrInfoRequestId = 0

	nuxtApp.provide("userService", {
		$getUserSummary: async () => {
			const successHandler = (res) => {
				const data = res.data

				//Notifications should be cleared in case we want to remove old ones.
				notificationStore.clear()
				notificationStore.storeNotificationsFromJson(data.notifications)

				userStore.clear()
				userStore.storeUserFromJson(data.user)

				//Orders are NOT expected to be removed or have their owners changed.
				//So do not clear old orders, just update them with the latest data.
				orderStore.updateOrdersFromJson(data.orders)

				//Credentials are expected to be removed or have their owners changed,
				//so we must clear out the old credentials and store the new ones.
				credentialStore.clear()
				credentialStore.storeCredentialsFromJson(data.credentials)

				//Events should be cleared in case we want to remove old ones.
				eventStore.clear()
				eventStore.storeEventsFromJson(data.events)
			}

			await $userApiService.$summary(successHandler)
		},

		$getUserQrInfo: async (eventId) => {
			const requestId = ++latestQrInfoRequestId
			qrInfoStore.$reset()

			const successHandler = (res) => {
				if (requestId !== latestQrInfoRequestId) {
					return
				}

				const data = res.data

				qrInfoStore.setQrCode(data.qr_code)
				qrInfoStore.setColor(data.color)
				qrInfoStore.setLane(data.lane)
			}

			await $userApiService.$qrInfo(eventId, successHandler)
		},

		$resetUserQrInfo: () => {
			latestQrInfoRequestId++
			qrInfoStore.$reset()
		},

		$updateUserInfo: async (userInfo) => {
			const successHandler = (res) => {
				const data = res.data
				userStore.clear()
				userStore.storeUserFromJson(data)

				toastStore.setSuccess($messages.$t("apiSuccess"))
				navigateTo("/myAccount")
			}

			await $userApiService.$updateUserInfo(userInfo, successHandler)
		},

		$updateUserPassword: async (currentPassword, newPassword) => {
			const requestBody = {
				current_password: currentPassword,
				new_password: newPassword,
			}

			const successHandler = () => {
				toastStore.setSuccess($messages.$t("apiSuccess"))
				navigateTo("/myAccount")
			}

			await $userApiService.$updateUserPassword(requestBody, successHandler)
		},

		$getUserImageUrl: () => {
			let userImage = userStore.getUser.image
			if (userImage) {
				return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "user/image/" + userImage + "?t=" + Date.now()
			} else {
				return runtimeConfig.public.IMAGES.NO_PHOTO
			}
		},

		$updateUserImage: async (imageBinary) => {
			const requestBody = {
				image: imageBinary,
			}

			const successHandler = (res) => {
				let data = res.data
				userStore.storeUserFromJson(data)
				toastStore.setSuccess($messages.$t("apiSuccess"))
				$eventBus.$emit(SAVED_PROFILE_IMAGE)
			}

			await $userApiService.$updateUserImage(requestBody, successHandler)
		},
	})
})
